"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ArrowRight, CreditCard, Nfc, ShieldCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PracticalAiAutomationForModernBusinesses() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: isCardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224158" id="practical-ai-automation-for-modern-businesses" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute -top-[20%] -right-[10%] w-[70%] h-[70%] rounded-lg bg-primary/10 blur-[120px]" />
        <div className="absolute -bottom-[20%] -left-[10%] w-[50%] h-[50%] rounded-lg bg-accent/20 blur-[100px]" />
      </div>

      <div className="container mx-auto px-6 max-w-7xl relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16 lg:gap-8">
          
          {}
          <div ref={textRef} className={`lg:w-[55%] flex flex-col items-start transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-accent text-accent-foreground text-sm font-medium mb-8">
              
              
            </div>
            
            <h1 className="text-[48px] lg:text-[64px] font-bold font-default leading-[1.1] text-foreground tracking-tighter">
              Practical <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-chart-2">AI Automation</span> for Modern Businesses
            </h1>
            
            <p className="text-[18px] leading-[1.6] text-muted-foreground mt-6 max-w-xl">
              Automate workflows, reporting, document handling, and repetitive operations using intelligent automation solutions designed to scale your efficiency.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 mt-10 w-full sm:w-auto">
              <Button size="lg" className="w-full sm:w-auto rounded-lg h-14 px-8 text-base bg-gradient-to-r from-primary to-chart-2 shadow-lg shadow-primary/30 border-none" onClick={() => document.getElementById('contactgetintouch')?.scrollIntoView({
              behavior: 'smooth'
            })}>
                Book Free Consultation
                <ArrowRight className="w-5 h-5 ml-2" />
              </Button>
              <Link to="/HomePage">
                
              </Link>
            </div>
            
            <div className="mt-12 flex items-center gap-6 text-sm text-muted-foreground">
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-lg bg-primary" />
                <span>Workflow Analysis</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-2 h-2 rounded-lg bg-primary" />
                <span>Custom Implementation</span>
              </div>
            </div>
          </div>

          {}
          <div ref={cardsRef} className={`lg:w-[45%] w-full relative h-[450px] lg:h-[600px] flex items-center justify-center perspective-1000 transition-all duration-1000 delay-300 ease-out ${isCardsVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="relative w-full max-w-[360px] aspect-[1.58/1]">
              
              {}
              <Card className="absolute inset-0 bg-card/40 backdrop-blur-md border border-white/10 shadow-2xl rotate-2 translate-y-12 translate-x-8 rounded-2xl p-6 flex flex-col justify-between transition-transform duration-500 hover:rotate-3 hover:translate-y-10 hover:translate-x-10">
                <div className="flex justify-between items-start">
                  <Nfc className="w-7 h-7 text-primary/60" />
                  <div className="font-bold italic text-foreground/80 font-default">DATAZEN</div>
                </div>
                <div className="mt-auto">
                  <div className="font-mono text-lg tracking-widest text-foreground/90 mb-3">
                    NODE_ID: 882-AI-FLOW
                  </div>
                  <div className="flex justify-between text-sm text-muted-foreground font-medium">
                    <span>SYSTEM STATUS</span>
                    <span>OPTIMIZED</span>
                  </div>
                </div>
              </Card>

              {}
              <Card className="absolute inset-0 bg-background/80 backdrop-blur-xl text-foreground shadow-2xl -rotate-3 -translate-y-2 -translate-x-4 rounded-2xl p-6 flex flex-col justify-between border border-white/5 transition-transform duration-500 hover:-rotate-4 hover:-translate-y-4 hover:-translate-x-6">
                <div className="flex justify-between items-start">
                  <Nfc className="w-7 h-7 text-primary" />
                  <div className="font-bold italic text-foreground font-default">DATAZEN</div>
                </div>
                <div className="mt-auto">
                  <div className="font-mono text-lg tracking-widest text-foreground/90 mb-3">
                    PROCESS_QUEUE: ACTIVE
                  </div>
                  <div className="flex justify-between text-sm text-muted-foreground font-medium">
                    <span>AUTOMATION HUB</span>
                    <span>v4.2.0</span>
                  </div>
                </div>
              </Card>

              {}
              <Card className="absolute inset-0 bg-gradient-to-br from-primary/20 to-chart-2/20 backdrop-blur-2xl border border-primary/30 shadow-3xl rotate-5 -translate-y-16 translate-x-2 rounded-2xl p-6 flex flex-col justify-between text-foreground transition-transform duration-500 hover:rotate-6 hover:-translate-y-20 hover:translate-x-4">
                <div className="absolute top-0 left-0 w-full h-full overflow-hidden rounded-2xl pointer-events-none">
                  <div className="absolute -top-1/2 -right-1/2 w-full h-full bg-primary/10 rotate-45 transform origin-bottom-left" />
                </div>
                <div className="relative z-10 flex justify-between items-start">
                  <CreditCard className="w-8 h-8 text-primary" />
                  <div className="font-bold italic text-foreground text-lg font-default">DATAZEN</div>
                </div>
                <div className="relative z-10 mt-auto">
                  <div className="font-mono text-xl tracking-widest text-foreground mb-3 drop-shadow-[0_0_10px_rgba(0,255,255,0.3)]">
                    FLOW_SYNC: 100%
                  </div>
                  <div className="flex justify-between text-sm text-muted-foreground font-medium">
                    <span>ANALYTICS ENGINE</span>
                    <span>SECURE</span>
                  </div>
                </div>
              </Card>

            </div>
          </div>

        </div>
      </div>
    </section>;
}